<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="text-uppercase justify-center">{{ metaData.header }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="py-4">
                        <product-form
                            @validated="onValidated"
                            @remove-image="removeImage"
                        ></product-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <snack-general
            :snack-data="snackData"
        ></snack-general>
        <load-overlay :overlay="overlay"></load-overlay>
    </v-container>
</template>

<script>
import ProductForm from "../../../components/forms/ProductForm";
import SnackGeneral from "../../../components/snacks/SnackGeneral";
import LoadOverlay from "../../../components/overlays/LoadOverlay";
import { MixinAppSnack, MixinProductForm } from "../../../mixins";
import { ProductsService } from "../../../services";
export default {
    name: "ProductAdd",
    mixins: [ MixinAppSnack, MixinProductForm ],
    components: {
        LoadOverlay,
        ProductForm,
        SnackGeneral
    },
    data() {
        return {
            metaUrl: '/products/add-product',
            overlay: false
        }
    },
    methods: {
        createProduct(data) {
            this.overlay = true;
            ProductsService.setAuth(this.$store.getters.token);
            ProductsService.create(this.getFormData(data))
                .then(() => {
                    this.snackHandle(this.$t('yourProductSaved'), 'main--black', true);
                    this.resetSnack();
                    this.setSuccessSnack();
                    this.setSnackText(this.$t('addProductSuccess'));
                    this.openSnack();
                    setTimeout(() => {
                        this.overlay = false;
                        this.$router.push({ name: 'Products.List' })
                    },4000)
                })
                .catch(err => {
                    const errData = err.response.data;
                    if(errData.error && errData.error.includes('Sending message error')) {
                        this.snackHandle(`${this.$t('addProductSuccess')} ${this.$t('sendMessageError')}` , 'warning', true);
                        setTimeout(() => {
                            this.overlay = false;
                            this.$router.push({ name: 'Products.List' })
                        },4000);
                    } else {
                        this.snackHandle(this.$t('changesSavedError') , 'error', true);
                        this.overlay = false;
                    }
                    console.log(err);
                });
        },
        onValidated(data) {
            this.createProduct(data);
        },
    }
}
</script>

<style scoped>

</style>
